import CommonAPI from './modules/common';
import DevicesAPI from './modules/devices/devices.api';
import UserAPI from './modules/user';
import OrganisationsAPI from './modules/organisations';
import AlarmsAPI from './modules/alarms/alarms.api';
import WorkflowsAPI from './modules/workflows/workflows.api';
import TasksAPI from './modules/tasks/tasks.api';
import TeamsAPI from './modules/teams/teams.api';
import EntitiesAPI from './modules/entities/entities.api';
import SchedulesAPI from './modules/schedules/schedules.api';
import TrainingRecordsAPI from './modules/trainingRecords/trainingRecords.api';
import MemberGroupsAPI from './modules/memberGroups';
import RisksAPI from './modules/risks';
import UnitsAPI from './modules/units/units.api';

class API extends CommonAPI {
  public common: CommonAPI;

  public user: UserAPI;

  public devices: DevicesAPI;

  public organisations: OrganisationsAPI;

  public alarms: AlarmsAPI;

  public workflows: WorkflowsAPI;

  public tasks: TasksAPI;

  public teams: TeamsAPI;

  public units: UnitsAPI;

  public entities: EntitiesAPI;

  public schedules: SchedulesAPI;

  public trainingRecords: TrainingRecordsAPI;

  public memberGroups: MemberGroupsAPI;

  public risks: RisksAPI;

  constructor() {
    super();
    this.common = new CommonAPI();
    this.user = new UserAPI();
    this.devices = new DevicesAPI();
    this.organisations = new OrganisationsAPI();
    this.alarms = new AlarmsAPI();
    this.workflows = new WorkflowsAPI();
    this.tasks = new TasksAPI();
    this.teams = new TeamsAPI();
    this.units = new UnitsAPI();
    this.entities = new EntitiesAPI();
    this.schedules = new SchedulesAPI();
    this.trainingRecords = new TrainingRecordsAPI();
    this.memberGroups = new MemberGroupsAPI();
    this.risks = new RisksAPI();
  }
}

export default new API();
